import Input from './Input'

const Password = (props) => {
  return <Input {...props} type="password" />
}

export default Password
